<template>
  <div>
    <b-button variant="primary" @click="setState">{{buttonText}}</b-button>
  </div>
</template>
<script>
import opportunityApi from "../../api/opportunity";

export default {
  name: "OpportunityPublish",
  props: {
    id: {
      required: true
    },
    state: {
      required: true
    },
    disabled: {
      required: false,
      default() {
        return false
      }
    }
  },
  computed: {
    buttonText() {
      return this.state ? "Unpublish" : "Publish";
    }
  },
  methods: {
    setState() {
      opportunityApi.putPublishState(this.id, !this.state).then(response => {
        this.$emit("updated");
      });
    }
  }
}
</script>